import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5qb9p6vh8d: FaireBrandEntity = {
  token: "b_5qb9p6vh8d",
  type: "brand",
  name: "SALINA TRADING INC",
  avatarUrl:
    "https://cdn.faire.com/fastly/0eb1ccf85679d4d207f8d7ec9730f31016507116f7f7da9770a3373ce147c8ab.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f86a8bb6d20dd5e0cbafbcd618bf2e1f32b2d545eca1baabf9627d2f7df09ef5.png",
  logoUrl:
    "https://cdn.faire.com/fastly/0eb1ccf85679d4d207f8d7ec9730f31016507116f7f7da9770a3373ce147c8ab.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f86a8bb6d20dd5e0cbafbcd618bf2e1f32b2d545eca1baabf9627d2f7df09ef5.png",
  location: "Denver, CO, USA",
  minimumOrderDollars: 100,
  rating: 4.1,
  reviewCount: 177,
  isInsider: false,
  description:
    "At GothicAttire, all orders are duty-free—we cover all import taxes, so you pay nothing extra (shipping fees still apply). Born from a deep respect for mystery, romance, and rebellion, our brand draws inspiration from the timeless beauty of Victorian elegance, dark romanticism, and the bold spirit of the modern Goth subculture.\n\nWe don’t just design clothes—we create visuals. Each piece is a statement of inner strength and captivating dark glamour. From tailored long coats to lace-trimmed shirts and metallic accessories, our collection blends classic Gothic silhouettes with modern, avant-garde styles, allowing the wearer to express themselves—or rather, dare to be.\n\nWhether stepping into the night or taking center stage, GothicAttire creates looks that make you feel stunning, confident, and unapologetically bold.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:47.139Z",
    importedBy: "entity-db-cli",
  },
};
